// src/components/ui/calendar/navigation/CalendarNavigationButtons/CalendarNavigationButtons.jsx
import React from 'react';
import { ChevronLeft, ChevronRight, RotateCcw } from 'lucide-react';

// shadcn components
import { Button } from '../../../button';

import { cn } from '../../../../../utils/cn';

const CalendarNavigationButtons = ({
  onPrevious,
  onNext,
  onToday,
  currentTitle,
  loading = false,
  className = ''
}) => {
  return (
    <div className={cn(
      "flex items-center gap-3",
      className
    )}>
      {/* Previous button */}
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={loading}
        className={cn(
          "p-2 rounded-lg bg-slate-800/30 hover:bg-slate-700/50 border-slate-600/30",
          "text-slate-400 hover:text-slate-200 transition-all duration-200 h-auto",
          "hover:scale-105 active:scale-95"
        )}
        title="Previous"
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>

      {/* Today button */}
      <Button
        variant="outline"
        onClick={onToday}
        disabled={loading}
        className={cn(
          "px-3 py-2 rounded-lg bg-slate-800/30 hover:bg-slate-700/50 border-slate-600/30",
          "text-slate-300 hover:text-slate-100 transition-all duration-200 font-medium text-sm h-auto",
          "hover:scale-105 active:scale-95",
          "flex items-center gap-2"
        )}
        title="Go to today"
      >
        <RotateCcw className="w-4 h-4" />
        Today
      </Button>

      {/* Next button */}
      <Button
        variant="outline"
        onClick={onNext}
        disabled={loading}
        className={cn(
          "p-2 rounded-lg bg-slate-800/30 hover:bg-slate-700/50 border-slate-600/30",
          "text-slate-400 hover:text-slate-200 transition-all duration-200 h-auto",
          "hover:scale-105 active:scale-95"
        )}
        title="Next"
      >
        <ChevronRight className="w-4 h-4" />
      </Button>

      {/* Current period title */}
      {currentTitle && (
        <div className="ml-4">
          <h2 className="text-xl font-bold text-slate-200">
            {currentTitle}
          </h2>
        </div>
      )}
    </div>
  );
};

export default CalendarNavigationButtons;